import { useAppSelector } from '../store/hooks';
import { useGetPromptQuery, selectPromptById } from '../store';

/**
 * Хук для получения промпта с оптимизацией кеша
 * Избегает дублирования запросов если промпт уже в EntityAdapter
 * @param promptId - ID промпта для получения
 * @param options - опции запроса
 * @returns объект с данными промпта и состоянием загрузки
 */
export const usePrompt = (promptId: number, options?: { skip?: boolean }) => {
    const { skip = false } = options || {};

    // Проверяем кеш
    const cachedPrompt = useAppSelector(state => selectPromptById(state, promptId));

    // Запрос только если промпта нет в кеше
    const {
        isFetching,
        isError,
        error,
        isSuccess: querySuccess,
    } = useGetPromptQuery({ promptId }, { skip: skip || Boolean(cachedPrompt) });

    return {
        data: cachedPrompt,
        isFetching: isFetching && !cachedPrompt,
        isLoading: isFetching && !cachedPrompt,
        isError: isError && !cachedPrompt,
        isSuccess: querySuccess || Boolean(cachedPrompt),
        error: cachedPrompt ? null : error,
        isFromCache: Boolean(cachedPrompt),
    };
};
